<template>
  <div class="content-8__content">
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>{{ isHK ? '日期/期数':'时间/期数' }}</th>
            <th>开奖号码</th>
            <th>特码</th>
            <th>正码1</th>
            <th>正码2</th>
            <th>正码3</th>
            <th>正码4</th>
            <th>正码5</th>
            <th>正码6</th>
            <th>特码</th>
            <th colspan="2">总肖</th>
          </tr>
        </thead>

        <tbody>
          <template v-for="(period, periodIndex) in tableData">
            <tr v-if="periodIndex < extendConut" :key="`${periodIndex}-tableData`">
              <!-- 期数 -->
              <td>
                <div class="tableballbox">
                  <span v-if="isHK" class="textbox__text">
                    {{ formatDrawTime(period.drawTime) }} {{ period.period.substr(4) }}期
                  </span>
                  <span v-else class="textbox__text">
                    {{ formatDrawTime(period.drawTime) }} {{ period.period }}期
                  </span>
                </div>
              </td>
              <!-- 开奖号码 -->
              <td>
                <div class="tableballbox">
                  <div v-for="(ball, ballIndex) in period.balls.slice(0,6)" :key="`${ballIndex}-ball`" class="tableballbox__item">
                    <!--TODO: .color-disable -->
                    <div
                      class="ball circle size-middle"
                      :class="getSebo(periodIndex,ballIndex)"
                    >
                      <span class="ball__number">{{ padZero(ball) }}</span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- 特码 -->
              <td>
                <div class="tableballbox">
                  <div class="tableballbox__item">
                    <div
                      class="ball circle size-middle"
                      :class="getSebo(periodIndex,6)"
                    >
                      <span class="ball__number">{{ padZero(period.balls[6]) }}</span>
                    </div>
                  </div>
                </div>
              </td>
              <!-- 正码1 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" v-html="SXFilter(period.shengXiao[0], period.shengXiaoDongWu[0])"></span>
                </div>
              </td>
              <!-- 正码2 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" v-html="SXFilter(period.shengXiao[1], period.shengXiaoDongWu[1])"></span>
                </div>
              </td>
              <!-- 正码3 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" v-html="SXFilter(period.shengXiao[2], period.shengXiaoDongWu[2])"></span>
                </div>
              </td>
              <!-- 正码4 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" v-html="SXFilter(period.shengXiao[3], period.shengXiaoDongWu[3])"></span>
                </div>
              </td>
              <!-- 正码5 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" v-html="SXFilter(period.shengXiao[4], period.shengXiaoDongWu[4])"></span>
                </div>
              </td>
              <!-- 正码6 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" v-html="SXFilter(period.shengXiao[5], period.shengXiaoDongWu[5])"></span>
                </div>
              </td>
              <!-- 特码 -->
              <td>
                <div class="tableballbox">
                  <span class="textbox__text" v-html="SXFilter(period.shengXiao[6], period.shengXiaoDongWu[6])"></span>
                </div>
              </td>
              <!-- 总肖 -->
              <td width="50px">
                <div class="tableballbox">
                  <span class="textbox__text">{{ period.shengXiaoZongHe[0] }}</span>
                </div>
              </td>
              <td width="50px">
                <div class="tableballbox">
                  <span class="textbox__text">{{ ruleCodeMapping[period.zongHeDanShuang[0]] }}</span>
                </div>
              </td>

            </tr>
          </template>
          <tr v-if="!noMore">
            <td colspan="12">
              <span class="button-primary c8-datebox__item active" @click="loadList">显示更多</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'
import moment from 'moment'

export default {
  name: 'ShengXiaoFenXi',
  props: {
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      extendConut: 30,
      selectFilterProperty: '',
      ruleCodeMapping: ruleCodeMapping
    }
  },
  computed: {
    noMore() {
      return this.extendConut >= this.tableData.length
    },
    isHK() {
      return this.$route.params.lottery_code === 'hk6'
    }
  },
  methods: {
    // 轉換utc時間格式
    formatDrawTime(time) {
      return this.isHK ? moment(time).format('YYYY/MM/DD') : moment(time).format('HH:mm')
    },
    // 過濾 生肖 動物
    SXFilter(shengXiao, dongWu) {
      return `<b>${ruleCodeMapping[shengXiao]}</b> ${ruleCodeMapping[dongWu]}`
    },
    // 拿顏色
    getSebo(periodIndex, ballIndex) {
      switch (this.tableData[periodIndex].seBo[ballIndex]) {
        case 'yanse_hong':
          return 'color--red'
        case 'yanse_lan':
          return 'color--blue'
        case 'yanse_lyu':
          return 'color--green'
        default:
          return ''
      }
    },
    // 一次性載入的數量
    loadList() {
      this.extendConut += 30
    },
    padZero(num) {
      return String(num).padStart(2, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
  .c8-datebox__item {
    &:hover {
      cursor: pointer;
    }
  }
</style>
